/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Add image alt tag
/* eslint-disable jsx-a11y/alt-text */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './ServiceSection.module.scss';

const ServiceSection: PageComponent = () => {
    // TODO: check responsive
    // TODO: make interactive
    const recommendsMax = 3;
    const [acitvePlan, setActivePlan] = useState(0);
    const prevActivePlan = () => {
        let index = acitvePlan;
        if (index < 1) {
            index = recommendsMax;
        } else {
            index -= 1;
        }
        setActivePlan(index);
    };
    const nextActivePlan = () => {
        let index = acitvePlan;
        if (index === recommendsMax) {
            index = 0;
        } else {
            index += 1;
        }
        setActivePlan(index);
    };
    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div
                    className={classNames(styles.container_inner, {
                        [styles.active]: acitvePlan === 0,
                    })}
                >
                    <span
                        className={styles.prev}
                        onClick={(e) => {
                            e.preventDefault();
                            prevActivePlan();
                        }}
                    />
                    <span
                        className={styles.next}
                        onClick={(e) => {
                            e.preventDefault();
                            nextActivePlan();
                        }}
                    />
                    <div className={styles.inside}>
                        <div className={styles.icon}>
                            <img src="/static/img/icons/backup.svg" />
                        </div>
                        <h3>
                            <Trans
                                i18nKey="services.dailyBackup.title"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                Nemokami kasdieniai backup'ai
                            </Trans>
                        </h3>
                        <p>
                            <Trans
                                i18nKey="services.dailyBackup.description"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                Jokio pavojaus dėl duomenų praradimo.
                            </Trans>
                        </p>
                    </div>
                </div>
                <div
                    className={classNames(styles.container_inner, {
                        [styles.active]: acitvePlan === 1,
                    })}
                >
                    <span
                        className={styles.prev}
                        onClick={(e) => {
                            e.preventDefault();
                            prevActivePlan();
                        }}
                    />
                    <span
                        className={styles.next}
                        onClick={(e) => {
                            e.preventDefault();
                            nextActivePlan();
                        }}
                    />
                    <div className={styles.inside}>
                        <div className={styles.icon}>
                            <img src="/static/img/icons/thunder-alt.svg" />
                        </div>
                        <h3>
                            <Trans
                                i18nKey="services.activation.title"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                Žaibiškas aktyvavimas
                            </Trans>
                        </h3>
                        <p>
                            <Trans
                                i18nKey="services.activation.description"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                Serveris aktyvuojamas per kelias akimirkas, bet
                                kuriuo paros metu.
                            </Trans>
                        </p>
                    </div>
                </div>
                <div
                    className={classNames(styles.container_inner, {
                        [styles.active]: acitvePlan === 2,
                    })}
                >
                    <span
                        className={styles.prev}
                        onClick={(e) => {
                            e.preventDefault();
                            prevActivePlan();
                        }}
                    />
                    <span
                        className={styles.next}
                        onClick={(e) => {
                            e.preventDefault();
                            nextActivePlan();
                        }}
                    />
                    <div className={styles.inside}>
                        <div className={styles.icon}>
                            <img src="/static/img/icons/speedometer.svg" />
                        </div>
                        <h3>
                            <Trans
                                i18nKey="services.ddos.title"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                Nemokama DDoS apsauga
                            </Trans>
                        </h3>
                        <p>
                            <Trans
                                i18nKey="services.ddos.description"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                Automatinė anti-DDoS sistema nuo įvairaus
                                pobūdžio atakų.
                            </Trans>
                        </p>
                    </div>
                </div>
                <div
                    className={classNames(styles.container_inner, {
                        [styles.active]: acitvePlan === 3,
                    })}
                >
                    <span
                        className={styles.prev}
                        onClick={(e) => {
                            e.preventDefault();
                            prevActivePlan();
                        }}
                    />
                    <span
                        className={styles.next}
                        onClick={(e) => {
                            e.preventDefault();
                            nextActivePlan();
                        }}
                    />
                    <div className={styles.inside}>
                        <div className={styles.icon}>
                            <img src="/static/img/icons/money-back.svg" />
                        </div>
                        <h3>
                            <Trans
                                i18nKey="services.moneyBack.title"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                30 dienų pinigų grąžinimo garantija
                            </Trans>
                        </h3>
                        <p>
                            <Trans
                                i18nKey="services.moneyBack.description"
                                ns="landingFeaturesReasonsTechnology"
                            >
                                Jokio vargo, jokios rizikos.
                            </Trans>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSection;
